<template>
  <div>
    <page-layout>
      <error-global ref="ErrorGlobal"></error-global>

      <div class="container">
        <h1>Deals</h1>

        <div class="deal" v-for="deal in deals" :key="deal.id" @click="viewDeal(deal.url)">
            <img class="deal__img" :src="deal.images[0].url_sm">
            <div class="deal__cnt">
                <div class="deal__title">{{ deal.title}}</div>
                <div class="deal__description">{{ deal.description }}</div>
            </div>
            <div class="deal__price">
              <div class="text-primary deal__price__text">{{ deal.price_text }}</div>
              <div class="deal__price__original">{{ deal.price_original_text }}</div>
            </div>
        </div>
        <div class="box__noevent" v-if="pageLoaded && deals.length == 0">
          No running deals.
        </div>

        <infinite-loading @infinite="getAll" :distance='100'>
          <div slot="no-more" class="text-sec margin-bottom"> </div>
        </infinite-loading>

      </div>

    </page-layout>
  </div>
</template>

<script>
import ErrorGlobal from '@/components/ErrorGlobal.vue';
import PageLayout from '@/components/PageLayout.vue';
import Http from '@/lib/http';
import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: 'deals',
  components: {
    ErrorGlobal,
    PageLayout,
    InfiniteLoading,
  },
  props: {},
  data() {
    return {
      deals: [],
      page: 1,
      pageLoaded: false,
    };
  },
  methods: {
    getAll($state) {
      if (!this.page) {
        return;
      }

      Http.get('deals/main', {
        page: this.page,
      }).then((response) => {
        this.pageLoaded = true;
        const dataDeals = response.data.deals;
        dataDeals.map((deal) => {
          const row = deal;
          return row;
        });
        this.deals.push(...dataDeals);

        $state.loaded();
        if (response.data.paginator.next) {
          this.page = response.data.paginator.next;
        } else {
          this.page = 0;
          $state.complete();
        }
      }).catch((error) => {
        if (error.response) {
          this.$refs.ErrorGlobal.show(error.response.data.error.message);
        }
      });
    },
    viewDeal(dealUrl) {
      // this.$router.push({ path: `deals/view/${dealId}` });
      window.location.href = dealUrl;
    },
  },
};
</script>

<style scoped>
/* deal */
.deal {
  display: flex;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eaeaea;
  cursor: pointer;
}
.deal:last-child {
  border-bottom: none;
  margin-bottom: 0;
}
.deal__img {
  width: 100px;
  padding-right: 20px;
  object-fit: contain;
  align-self: flex-start;
}
.deal__cnt {
  flex: 1 1 auto;
}
.deal__title {
  font-weight: 500;
  margin-bottom: 5px;
}
.deal__description {
  color: #858585;
  line-height: 1.2em;
}

.deal__price {
  padding-left: 10px;
  text-align: right;
}
.deal__price__original {
  font-size: 14px;
  color: #888;
  text-decoration: line-through;
}
.deal__price__text {
  font-weight: 500;
}
</style>
